export class Account {
    constructor(
        public activated: boolean,
        public authorities: string[],
        public email: string,
        public civilite: string,
        public firstName: string,
        public otherNames: string,
        public lastName: string,
        public lastNameUsage: string,
        public birthDate: Date,
        public langKey: string,
        public login: string,
        public imageUrl: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/account.model.ts